export const handleResponse = (resolve) => (response) => resolve(response.data);
export const handleError = (reject) => (error) => reject(error);
